import MojitoCore from 'mojito/core';
const UIView = MojitoCore.Presentation.UIView;
import LeaguesFilterSectionImpl from './leagues-filter-section.js';
import PropTypes from 'prop-types';

/**
 * LeaguesFilterSection - wrapper component that allows to filter content by selected events group/league.
 *
 * @class LeaguesFilterSection
 * @memberof Mojito.Applications.Sports.Pages
 */

/**
 * LeaguesFilterSection propTypes.
 *
 * @property {string} [groupId] - Group id to load. Will be used to present available leagues filter.
 * @property {node|Function} [children] - Children to render.
 *
 * @memberof Mojito.Applications.Sports.Pages.LeaguesFilterSection
 */
const propTypes = {
    groupId: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
};

export default UIView('LeaguesFilterSection', LeaguesFilterSectionImpl, propTypes);
